import script from "./FeedbackTemplateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackTemplateDialog.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackTemplateDialog.vue?vue&type=style&index=0&id=12b6a20f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b6a20f"]])

export default __exports__